import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=b7f4d78c&scoped=true&"
import script from "./DownloadButton.vue?vue&type=script&lang=ts&"
export * from "./DownloadButton.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadButton.vue?vue&type=style&index=0&id=b7f4d78c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f4d78c",
  null
  
)

export default component.exports